module.exports = __webpack_public_path__ + "static/img/bg_1.e874b69.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg_1.png
// module id = F0mD
// module chunks = 9